// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.coustomContactUsBg {
  background-color: #5b7cfd;
  margin-top: 20px;
  padding-bottom: 20px;
}

@media (min-width: 768px) {
  /* Apply styles for medium-sized screens and above */
  .coustomContactUsBg {
    height: 451px; /* Set the desired height for medium-sized screens and above */
    margin-top: 48px;
  }
}

.markitingImageAligenment {
  margin-left: -10px;
  width: 650px;
  height: auto;
}
@media only screen and (max-width: 767.98px) {
  .markitingImageAligenment {
    width: 585px;
    height: auto;
    margin-top: 20px;
  }
}

.contactUsHeadingMainPage {
  margin-top: 40px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 60px;
  color: #ffffff;
}

@media only screen and (max-width: 767.98px) {
  /* Screens below medium */
  .contactUsHeadingMainPage {
    color: #fff;
    font-family: "Roboto";
    font-size: 32px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: ;
  }
}

.contactUsPara {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 25px;
  color: #ffffff;
}
@media only screen and (max-width: 767.98px) {
  .contactUsPara {
    font-size: 14px;
  }
}
.contactUsButtonBox {
  width: 177px;
  height: 56px;
  background-color: white;
  border-radius: 4px;
}
@media only screen and (max-width: 767.98px) {
  .contactUsButtonBox {
    height: 40px;
    width: 160px;
  }
  .contactUsPara {
    color: #fff;
    font-family: Roboto;
    font-size: 0.9rem;
    opacity: 0.95;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5625rem;
  }
}
.contactUsButtonText {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #5b7cfd;
  padding-top: 20px;
}
@media only screen and (max-width: 767.98px) {
  .contactUsButtonText {
    padding-top: 12px;
  }
}
.buttonsRowContactUs {
  margin-top: 88.5px;
  padding-bottom: 20px;
}
@media only screen and (max-width: 767.98px) {
  .buttonsRowContactUs {
    margin-top: 30px;
    /* padding-bottom: 20px; */
  }
}

.learnButtonBox {
  width: 177px;
  height: 56px;
  border-radius: 4px;
  border: 1px solid white;
}
@media only screen and (max-width: 767.98px) {
  .learnButtonBox {
    height: 40px;
    width: 160px !important;
  }
}

.learnButtonCoustomText {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: white;
  padding-top: 19px !important;
}
@media only screen and (max-width: 767.98px) {
  .learnButtonCoustomText {
    padding-top: 10px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Homepage/MudasirScreens/HRManagement/components/ContactUs/ContactUs.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;EACpD;IACE,aAAa,EAAE,8DAA8D;IAC7E,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;AACd;AACA;EACE;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB;IACE,WAAW;IACX,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE;IACE,YAAY;IACZ,YAAY;EACd;EACA;IACE,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;EACxB;AACF;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE;IACE,gBAAgB;IAChB,0BAA0B;EAC5B;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE;IACE,YAAY;IACZ,uBAAuB;EACzB;AACF;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE;IACE,4BAA4B;EAC9B;AACF","sourcesContent":[".coustomContactUsBg {\n  background-color: #5b7cfd;\n  margin-top: 20px;\n  padding-bottom: 20px;\n}\n\n@media (min-width: 768px) {\n  /* Apply styles for medium-sized screens and above */\n  .coustomContactUsBg {\n    height: 451px; /* Set the desired height for medium-sized screens and above */\n    margin-top: 48px;\n  }\n}\n\n.markitingImageAligenment {\n  margin-left: -10px;\n  width: 650px;\n  height: auto;\n}\n@media only screen and (max-width: 767.98px) {\n  .markitingImageAligenment {\n    width: 585px;\n    height: auto;\n    margin-top: 20px;\n  }\n}\n\n.contactUsHeadingMainPage {\n  margin-top: 40px;\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 48px;\n  line-height: 60px;\n  color: #ffffff;\n}\n\n@media only screen and (max-width: 767.98px) {\n  /* Screens below medium */\n  .contactUsHeadingMainPage {\n    color: #fff;\n    font-family: \"Roboto\";\n    font-size: 32px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin-top: ;\n  }\n}\n\n.contactUsPara {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 25px;\n  color: #ffffff;\n}\n@media only screen and (max-width: 767.98px) {\n  .contactUsPara {\n    font-size: 14px;\n  }\n}\n.contactUsButtonBox {\n  width: 177px;\n  height: 56px;\n  background-color: white;\n  border-radius: 4px;\n}\n@media only screen and (max-width: 767.98px) {\n  .contactUsButtonBox {\n    height: 40px;\n    width: 160px;\n  }\n  .contactUsPara {\n    color: #fff;\n    font-family: Roboto;\n    font-size: 0.9rem;\n    opacity: 0.95;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.5625rem;\n  }\n}\n.contactUsButtonText {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  color: #5b7cfd;\n  padding-top: 20px;\n}\n@media only screen and (max-width: 767.98px) {\n  .contactUsButtonText {\n    padding-top: 12px;\n  }\n}\n.buttonsRowContactUs {\n  margin-top: 88.5px;\n  padding-bottom: 20px;\n}\n@media only screen and (max-width: 767.98px) {\n  .buttonsRowContactUs {\n    margin-top: 30px;\n    /* padding-bottom: 20px; */\n  }\n}\n\n.learnButtonBox {\n  width: 177px;\n  height: 56px;\n  border-radius: 4px;\n  border: 1px solid white;\n}\n@media only screen and (max-width: 767.98px) {\n  .learnButtonBox {\n    height: 40px;\n    width: 160px !important;\n  }\n}\n\n.learnButtonCoustomText {\n  font-family: \"Roboto\";\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  color: white;\n  padding-top: 19px !important;\n}\n@media only screen and (max-width: 767.98px) {\n  .learnButtonCoustomText {\n    padding-top: 10px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
